import React from 'react'
import Input from 'components/Input'
import PhoneNumberInput from 'components/PhoneNumberInput'
import { withTranslation } from 'react-i18next'

const StepTwoForm = ({ t }) => {

  const fields = [
    {
      name: 'first_name',
      label: t('registration.field.fname'),
      placeholder: t('registration.field.fname_placeholder')
    },
    {
      name: 'last_name',
      label: t('registration.field.lname'),
      placeholder: t('registration.field.lname_placeholder')
    },
    {
      name: 'email',
      label: t('registration.field.work_email'),
      placeholder: t('registration.field.bmail_placeholder')
    },
    {
      name: 'phone',
      label: t('registration.field.phone')
    },
    {
      name: 'job_title',
      label: t('registration.field.job_title'),
      placeholder: t('registration.field.job_title_placeholder')
    }
  ]

  return (
    <div className="flex flex-col gap-4">
      {
        fields.map(field => {
          return (
            <div key={field.name}>
              {
                field.name === 'phone' ? (
                  <PhoneNumberInput
                    name={field.name}
                    label={field.label}
                    className="w-full border border-border-lines p-3 rounded-lg bg-white"
                  />
                ) : (
                  <Input
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    classList='!bg-white !border-border-lines rounded-lg placeholder:text-placeholder'
                  />
                )
              }
            </div>
          )
        })
      }
    </div>
  )
}



export default withTranslation()(StepTwoForm)
